/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var spine_core_event_pb = require('../../../../spine/core/event_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
var spine_system_server_entity_history_pb = require('../../../../spine/system/server/entity_history_pb.js');
goog.exportSymbol('proto.spine.system.server.DispatchCommandToHandler', null, global);
goog.exportSymbol('proto.spine.system.server.DispatchEventToReactor', null, global);
goog.exportSymbol('proto.spine.system.server.DispatchEventToSubscriber', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.DispatchEventToSubscriber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.DispatchEventToSubscriber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.DispatchEventToSubscriber.displayName = 'proto.spine.system.server.DispatchEventToSubscriber';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.DispatchEventToSubscriber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.DispatchEventToSubscriber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchEventToSubscriber.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && spine_core_event_pb.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.DispatchEventToSubscriber}
 */
proto.spine.system.server.DispatchEventToSubscriber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.DispatchEventToSubscriber;
  return proto.spine.system.server.DispatchEventToSubscriber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.DispatchEventToSubscriber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.DispatchEventToSubscriber}
 */
proto.spine.system.server.DispatchEventToSubscriber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.Event;
      reader.readMessage(value,spine_core_event_pb.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.DispatchEventToSubscriber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.DispatchEventToSubscriber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchEventToSubscriber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.DispatchEventToSubscriber.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.DispatchEventToSubscriber.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Event event = 2;
 * @return {?proto.spine.core.Event}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.getEvent = function() {
  return /** @type{?proto.spine.core.Event} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2));
};


/** @param {?proto.spine.core.Event|undefined} value */
proto.spine.system.server.DispatchEventToSubscriber.prototype.setEvent = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.DispatchEventToSubscriber.prototype.clearEvent = function() {
  this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchEventToSubscriber.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.DispatchEventToReactor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.DispatchEventToReactor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.DispatchEventToReactor.displayName = 'proto.spine.system.server.DispatchEventToReactor';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.DispatchEventToReactor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.DispatchEventToReactor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchEventToReactor.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && spine_core_event_pb.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.DispatchEventToReactor}
 */
proto.spine.system.server.DispatchEventToReactor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.DispatchEventToReactor;
  return proto.spine.system.server.DispatchEventToReactor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.DispatchEventToReactor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.DispatchEventToReactor}
 */
proto.spine.system.server.DispatchEventToReactor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.Event;
      reader.readMessage(value,spine_core_event_pb.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.DispatchEventToReactor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.DispatchEventToReactor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchEventToReactor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.DispatchEventToReactor.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.DispatchEventToReactor.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Event event = 2;
 * @return {?proto.spine.core.Event}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.getEvent = function() {
  return /** @type{?proto.spine.core.Event} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2));
};


/** @param {?proto.spine.core.Event|undefined} value */
proto.spine.system.server.DispatchEventToReactor.prototype.setEvent = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.DispatchEventToReactor.prototype.clearEvent = function() {
  this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchEventToReactor.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.DispatchCommandToHandler = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.DispatchCommandToHandler, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.DispatchCommandToHandler.displayName = 'proto.spine.system.server.DispatchCommandToHandler';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.DispatchCommandToHandler.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.DispatchCommandToHandler} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchCommandToHandler.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    command: (f = msg.getCommand()) && spine_core_command_pb.Command.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.DispatchCommandToHandler}
 */
proto.spine.system.server.DispatchCommandToHandler.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.DispatchCommandToHandler;
  return proto.spine.system.server.DispatchCommandToHandler.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.DispatchCommandToHandler} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.DispatchCommandToHandler}
 */
proto.spine.system.server.DispatchCommandToHandler.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_command_pb.Command;
      reader.readMessage(value,spine_core_command_pb.Command.deserializeBinaryFromReader);
      msg.setCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.DispatchCommandToHandler.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.DispatchCommandToHandler} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchCommandToHandler.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getCommand();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.Command.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.DispatchCommandToHandler.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.DispatchCommandToHandler.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Command command = 2;
 * @return {?proto.spine.core.Command}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.getCommand = function() {
  return /** @type{?proto.spine.core.Command} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 2));
};


/** @param {?proto.spine.core.Command|undefined} value */
proto.spine.system.server.DispatchCommandToHandler.prototype.setCommand = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.DispatchCommandToHandler.prototype.clearCommand = function() {
  this.setCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchCommandToHandler.prototype.hasCommand = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.DispatchEventToSubscriber.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.DispatchEventToSubscriber.fromObject(jsObject);
};

proto.spine.system.server.DispatchEventToSubscriber.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.DispatchEventToSubscriber();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.event !== undefined) {
    if (obj.event === null) {
      msg.setEvent(null);
    } else {
      let value = proto.spine.core.Event.fromObject(obj.event);
      msg.setEvent(value);
    }
  }
  return msg;
};

proto.spine.system.server.DispatchEventToReactor.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.DispatchEventToReactor.fromObject(jsObject);
};

proto.spine.system.server.DispatchEventToReactor.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.DispatchEventToReactor();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.event !== undefined) {
    if (obj.event === null) {
      msg.setEvent(null);
    } else {
      let value = proto.spine.core.Event.fromObject(obj.event);
      msg.setEvent(value);
    }
  }
  return msg;
};

proto.spine.system.server.DispatchCommandToHandler.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.DispatchCommandToHandler.fromObject(jsObject);
};

proto.spine.system.server.DispatchCommandToHandler.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.DispatchCommandToHandler();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.command !== undefined) {
    if (obj.command === null) {
      msg.setCommand(null);
    } else {
      let value = proto.spine.core.Command.fromObject(obj.command);
      msg.setCommand(value);
    }
  }
  return msg;
};
